import React from 'react';

import { LegacyIconProps } from './iconUtilities';

export function PinMarkerIcon({ 
    width = 26, 
    height = 26, 
    color = '#2E98E3'
}: LegacyIconProps) {
    return (
        <svg id='mapPinMarkerIcon' className='mapIcon' viewBox='0 0 16 26' width={width} height={height} fill={color}>
            <path d='M8.0001181,0.511016063 C3.58187804,0.511016063 0,4.29070526 0,8.95269579 C0,9.0526401 0.00283432485,9.15432906 0.00708581214,9.25701498 C0.0370824169,10.1438026 0.195568415,10.9954477 0.46506547,11.7922605 C2.17180142,17.7121535 8.0001181,25.4347826 8.0001181,25.4347826 C8.0001181,25.4347826 13.8277262,17.7129013 15.5346983,11.7930082 C15.8046678,10.9961954 15.9629176,10.1438026 15.992678,9.25701498 C15.9974019,9.15432906 16,9.05288933 16,8.95269579 C16.0002362,4.29070526 12.4183582,0.511016063 8.0001181,0.511016063 L8.0001181,0.511016063 Z' strokeWidth='0'></path>
            <circle cx='8.05002441' cy='8.74997559' r='3.65' fill='white' strokeWidth='0'></circle>
        </svg>
    );
}
